import { defineStore } from 'pinia'
import { shallowRef } from 'vue'
import type { Hero } from '@/models/hero'

export type HeroData = {
  id: number | string
  type?: string
  slug?: string
  title?: string
  media?: number
  hero?: Hero
}

export const useHeroStore = defineStore('hero', () => {
  const data = shallowRef<HeroData | null>(null)

  function setHeroFromSegment(content: {
    id?: number | string
    type?: string
    slug?: string
    title?: string
    media?: number
    hero?: Hero
  }) {
    if (!content.hero) {
      data.value = null
      return
    }

    data.value = {
      id: content.id!,
      type: content.type,
      slug: content.slug,
      title: content.title,
      media: content.media,
      hero: content.hero,
    }
  }

  function clearHero() {
    data.value = null
  }

  return {
    data,
    setHeroFromSegment,
    clearHero,
  }
})
